var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Releases",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeOpacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stores-(Add-Location)",
    transform: "translate(-546.000000, -462.000000)",
    stroke: "#F7EFF3",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(500.000000, 339.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Select-Field-Required-Copy-4",
    transform: "translate(30.000000, 103.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,40 L32.364,36.364 M32.364,36.364 C33.9926,34.7353 35,32.4853 35,30 C35,25.02944 30.9706,21 26,21 C21.02944,21 17,25.02944 17,30 C17,34.9706 21.02944,39 26,39 C28.4853,39 30.7353,37.9926 32.364,36.364 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAddressIcon);
export default __webpack_public_path__ + "static/media/search-address-icon.ef2c35a5b2a1dfa6bf7b135cd2c5b7f3.svg";
export { ForwardRef as ReactComponent };